<template>
  <v-card class="elevation-0 px-0">
    <v-card-text class="px-0">
      <v-row class="mb-1 ta-center">
        <v-col>
          <div class="c-dark-blue fs-18 fw-500 mb-1">Find providers that fit your schedule</div>
          <div class="c-dark-blue fs-26 fw-600 mb-2">Select the days and times you are looking for care</div>
        </v-col>
      </v-row>

      <v-row class="mb-0">
        <v-col>
          <div class="c-dark-blue fs-16 fw-400">What is your ideal <strong>drop off time</strong> each day?</div>
        </v-col>
      </v-row>

      <v-row class="mb-1 justify-center">
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.dropoff == 500 ? pressed : not" @click="search.dropoff = 500" class="fullwidth">5:00 AM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.dropoff == 600 ? pressed : not" @click="search.dropoff = 600" class="fullwidth">6:00 AM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.dropoff == 700 ? pressed : not" @click="search.dropoff = 700" class="fullwidth">7:00 AM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.dropoff == 800 ? pressed : not" @click="search.dropoff = 800" class="fullwidth">8:00 AM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.dropoff == 900 ? pressed : not" @click="search.dropoff = 900" class="fullwidth">9:00 AM</v-btn>
        </v-col>
      </v-row>

      <v-row class="mb-0">
        <v-col>
          <div class="c-dark-blue fs-16 fw-400">What is your ideal <strong>pick up time</strong> each day?</div>
        </v-col>
      </v-row>

      <v-row class="mb-1 justify-center">
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.pickup == 1400 ? pressed : not" @click="search.pickup = 1400" class="fullwidth">2:00 PM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.pickup == 1500 ? pressed : not" @click="search.pickup = 1500" class="fullwidth">3:00 PM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.pickup == 1600 ? pressed : not" @click="search.pickup = 1600" class="fullwidth">4:00 PM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.pickup == 1700 ? pressed : not" @click="search.pickup = 1700" class="fullwidth">5:00 PM</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="search.pickup == 6 ? pressed : not" @click="search.pickup = 6" class="fullwidth">6:00 PM</v-btn>
        </v-col>
      </v-row>

      <v-row class="mb-0">
        <v-col>
          <div class="c-dark-blue fs-16 fw-400">Which <strong>days of the week</strong> would you like coverage for?</div>
        </v-col>
      </v-row>

      <v-row class="mb-1 justify-center">
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="coverage.get(0) ? pressed : not" @click="toggleCoverage(0)" class="fullwidth">Monday</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="coverage.get(1) ? pressed : not" @click="toggleCoverage(1)" class="fullwidth">Tuesday</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="coverage.get(2) ? pressed : not" @click="toggleCoverage(2)" class="fullwidth">Wednesday</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="coverage.get(3) ? pressed : not" @click="toggleCoverage(3)" class="fullwidth">Thursday</v-btn>
        </v-col>
        <v-col class="px-1" sm="2" xs="6">
          <v-btn :class="coverage.get(4) ? pressed : not" @click="toggleCoverage(4)" class="fullwidth">Friday</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: function() {
    return {
      coverage: this.newCoverageMap(),
      not: ['v-btn--outlined', 'v-btn--text', 'ghostly'],
      pressed: ['v-btn--depressed', 'secondary'],
    }
  },

  methods: {
    convertCoverageArrayToSearchString: function() {
      this.search.coverage = Array.from(this.coverage)
        .filter(function(day) { return day[1] == true })
          .map(function(day) { return day[0] })
            .join(",")
    },

    newCoverageMap: function() {
      var values;
      if(this.search.coverage == "") {
        values = []
      } else {
        values = this.search.coverage.split(",")
      }
      var map = new Map()
      if(values.length == 0) {
        return map
      }
      for(var v in values) {
        map.set(parseInt(values[v]), true)
      }
      return map
    },

    toggleCoverage: function(value) {
      this.coverage.set(value, !this.coverage.get(value))
      this.convertCoverageArrayToSearchString()
      this.$forceUpdate()
    },
  },

  props: ['search']
}
</script>
